module.exports = __webpack_public_path__ + "img/step-1.e6430cd3.png";